import { Info } from "lucide-react";

import Badge from "../../../../Components/Badge";
import Table from "../../../../Components/Table";
import {
  getAccountLevelVerboseLabel,
  getLevelCompactName,
} from "../../../../Utils/Helper/levelUtils";

interface XFactorLevelGuideProps {
  showHeader?: boolean;
  compact?: boolean;
  className?: string;
  organizationLevels?: Array<{
    level_code?: string;
    levels?: string;
    name: string;
    description: string;
  }>;
  selectedLevel?: string | null;
}

const XFactorLevelGuide: React.FC<XFactorLevelGuideProps> = ({
  showHeader = true,
  compact = false,
  className = "",
  organizationLevels = [],
  selectedLevel = null,
}) => {
  const tableData = organizationLevels.map(level => ({
    level: level.level_code || level.levels || "",
    name: level.name,
    description: level.description,
  }));

  const selectedLevelData = organizationLevels.find(
    l => (l.level_code || l.levels) === selectedLevel
  );

  return (
    <div
      className={`bg-blue-50 border border-blue-200 rounded-lg p-4 ${className}`}
    >
      {showHeader && (
        <div className="flex items-center space-x-2 mb-3">
          <Info className="h-5 w-5 text-blue-600" />
          <h4 className="font-semibold text-blue-900 text-lg mb-0">
            XFACTOR™ Account Level Definitions
          </h4>
        </div>
      )}

      {showHeader && !compact && (
        <p className="text-sm text-blue-700 mb-4">
          Structured across {organizationLevels.length} Account Levels (AL) that
          describe a customers evolving relationship with your organization as a
          vendor. This is valuable for strategic account planning, customer
          success, and revenue expansion initiatives.
        </p>
      )}

      <div className="x-factor">
        {" "}
        <Table
          columns={[
            {
              key: "level",
              title: "AL",
              width: "80px",
              render: (value: string) => getLevelCompactName(value),
            },
            { key: "name", title: "Name", width: "160px" },
            { key: "description", title: "Description" },
          ]}
          data={tableData}
          rowKey={(r: { level: string }) => r.level}
          className="xfactor-table"
        />
        {selectedLevel && selectedLevelData && (
          <Badge
            label={`Selected: ${getAccountLevelVerboseLabel(selectedLevel, selectedLevelData.name)}`}
            type="long-assessment-purple"
            className="assessment-type-badge review-assessment__radio-selection mt-2"
          />
        )}
      </div>

      {compact && (
        <div className="mt-3 text-xs text-blue-600 text-center">
          Use this framework to assess the customers current relationship
          maturity level
        </div>
      )}
    </div>
  );
};

export default XFactorLevelGuide;
